var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable, IFirebaseAnalyticsDataSourceType } from '@serviceos-rn/core';
import { TipConfig } from '../../TipConfig';
let TipAnalyticsEventsRepository = class TipAnalyticsEventsRepository {
    constructor(analyticsDataSource) {
        this.analyticsDataSource = analyticsDataSource;
    }
    addContextParams(event) {
        if (event.value !== undefined) {
            event.value = `${event.value}`;
        }
        return event;
    }
    sendTipAmountSelectedEvent(value) {
        this.addContextParams(value);
        this.analyticsDataSource.sendEvent(TipConfig.moduleName, 'tip_amount_selected', value);
        return value;
    }
    sendTipSubmittedEvent(value) {
        this.addContextParams(value);
        this.analyticsDataSource.sendEvent(TipConfig.moduleName, 'tip_submitted', value);
        return value;
    }
    sendAddAnotherTipButtonTappedEvent(value) {
        this.addContextParams(value);
        this.analyticsDataSource.sendEvent(TipConfig.moduleName, 'add_another_tip_button_tapped', value);
        return value;
    }
    sendTipFailedEvent(value) {
        this.addContextParams(value);
        this.analyticsDataSource.sendEvent(TipConfig.moduleName, 'tip_failed', value);
        return value;
    }
    sendTipSuccessEvent(value) {
        this.addContextParams(value);
        this.analyticsDataSource.sendEvent(TipConfig.moduleName, 'tip_success', value);
        return value;
    }
};
TipAnalyticsEventsRepository = __decorate([
    injectable({
        type: 'singleton'
    }),
    __param(0, inject(IFirebaseAnalyticsDataSourceType)),
    __metadata("design:paramtypes", [Object])
], TipAnalyticsEventsRepository);
export { TipAnalyticsEventsRepository };
